import React, {PropsWithChildren} from "react";

export type WithStyle = {
    style?: React.CSSProperties;
};

export type WithClick = {
    onClick: () => void;
};

export const ActionButton = (props: PropsWithChildren<WithStyle & WithClick>) => {

    const buttonStyle: React.CSSProperties = {
        position: 'absolute',
        right: '32px',
        bottom: '32px',
        borderWidth: '0px',
        borderRadius: '32px',
        backgroundColor: '#61ddff',
        width: '64px',
        height: '64px',
        textAlign: 'center',
        lineHeight: '64px',
        ...props.style,
    };

    return (
        <button style={buttonStyle} onClick={props.onClick}>
            {props.children}
        </button>
    );
};